// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JBXJ","badges":"styles_badges__10Z6l"};